<label class="radio-btn">
    <input type="radio" [attr.name]="radioBtnGroup" (change)="radioCheckedChanged($event)" (click)="setRadioLock($event)" [checked]="checked"/>
    <span class="round"></span>
    <span class="radio-label text-body-s">{{ labelText }}</span>
</label>